// extracted by mini-css-extract-plugin
module.exports = {"card":"_02712f2b3b--card--Pkhyq","title":"_02712f2b3b--title--ty5o7","rate-info":"_02712f2b3b--rate-info--orymW","info-icon":"_02712f2b3b--info-icon--AUtJc"};